import * as React from 'react';

import ShareLink from '../share-link';
import ProgressBlockContainer from '../progress-block';
import Invitee from './invitee';
import { IDashboardPageProps } from './dashboard-page.types';
import { checkInviteeWidgetAvailable } from './dashboard-page.utils';
import FRFriendListLoaderContainer from '../fr-friend-list';
import { translate } from 'components/translate-hoc';
import { DASHBOARD_PAGE_TEXTS } from './dashboard-page.constants';
import './dashboard-page.styles.less';

export class DashboardPage extends React.Component<IDashboardPageProps> {
    public renderInviteeWidget(): JSX.Element | null {
        const { referrerId, isConverted } = this.props;
        const isInviteeWidgetAvailable = checkInviteeWidgetAvailable(referrerId, isConverted);
        return isInviteeWidgetAvailable
            ? <Invitee/>
            : null;
    }
    public render(): JSX.Element {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            originalTranslateKey,
        } = this.props;
        const gameName: string = originalTranslateKey(DASHBOARD_PAGE_TEXTS.GAME_NAME);

        return (
            <div className="sitegen-friend-referral-dashboard-page">
                {this.renderInviteeWidget()}
                <div className="sitegen-friend-referral-dashboard-page__caption">
                    {translateKey(DASHBOARD_PAGE_TEXTS.CAPTION)}
                </div>
                <div className="sitegen-friend-referral-dashboard-page__title">
                    {translateKey(DASHBOARD_PAGE_TEXTS.TITLE)}
                </div>
                <div className="sitegen-friend-referral-dashboard-page__subtitle">
                    {translateKey(DASHBOARD_PAGE_TEXTS.SUBTITLE, { gameName })}
                </div>

                <div className="sitegen-friend-referral-dashboard-page__progression-block">
                    <ProgressBlockContainer />
                </div>
                <div className="sitegen-friend-referral-dashboard-page__invite-link-and-friend-list-block">
                    <ShareLink />
                    <FRFriendListLoaderContainer />
                </div>
            </div>
        );
    }
}

export default translate()(DashboardPage);
